export const REGEXP = {
  POSTAL_CODE: /^\d{3}-\d{4}$/,
  TEL: /^0\d{1,3}-\d{2,4}-\d{3,4}$/,
}
